export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.9.0',
};
//# sourceMappingURL=buildEnv.js.map